// 复用生成器导出的 API 实例，保留各接口的参数和返回值类型。
import { api, apiInstanceList } from '@/service'
// 使用 WMS 原有拦截器，统一鉴权、灰度、版本检查和业务提示。
import { getHandleResponse, handleRequest, handleRequestError, handleResponseError } from '@/axios'
// 使用当前 Axios 版本的请求配置类型。
import type { AxiosRequestConfig } from 'axios'

/**
 * 将生成请求交给现有拦截器；config 的实际请求地址保持不变。
 * 合并地址仅用于识别 baseURL 为 /customer、url 为 /users/token 的登录请求。
 */
const handleGeneratedRequest = (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  // 生成器提供的接口路径，也兼容调用者指定的绝对地址。
  const url = config.url || ''
  // 已是绝对地址时不追加 baseURL，避免影响登录接口判断。
  const isAbsoluteUrl = /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url)
  // 与 Axios 拼接规则一致的完整地址，仅作为鉴权判断的输入。
  const requestUrl = config.baseURL && !isAbsoluteUrl
    ? `${config.baseURL.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`
    : url
  return handleRequest(config, requestUrl)
}

// item 是生成器注册的服务实例；为每个独立 Axios 实例接入共享拦截器。
apiInstanceList.forEach((item) => {
  item.instance.instance.interceptors.request.use(handleGeneratedRequest, handleRequestError)
  item.instance.instance.interceptors.response.use(getHandleResponse(true), handleResponseError)
})

/** TS 请求入口：request.服务名.控制器.接口方法，直接获得生成器的类型提示。 */
export const request = api
